import { render, staticRenderFns } from "./MetaCampaignForm.vue?vue&type=template&id=5666035f"
import script from "./MetaCampaignForm.vue?vue&type=script&lang=js"
export * from "./MetaCampaignForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports